import { ADD_ALERT, REMOVE_ALERT, ADD_ALERT_SUCCESS, ADD_ALERT_DANGER } from './actionTypes';
import IAction from '../../models/action.model';

const defaultStore: any = {
    isActive: false,
}

export default function alert(
state: any = defaultStore,
action: IAction,
) {
switch (action.type) {
  case ADD_ALERT: 
    return {
        isActive: true,
        payload: action.payload
    };
  
    case ADD_ALERT_SUCCESS: 
    return {
        isActive: true,
        payload: {
          ...action.payload,
          className: 'is-success'
        }
    };

  case ADD_ALERT_DANGER: 
    return {
        isActive: true,
        payload: {
          ...action.payload,
          className: 'is-danger'
        }
    };

  case REMOVE_ALERT: 
    return {
        ...state,
        isActive: false,
    }
    
  default:
    return state;
}
}
